/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool,
    func,
    node,
    object,
    string,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import {
    Dialog, DialogContent, DialogTitle,
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';

const useStyle = makeStyles((theme) => ({
    addonsVerification: {
        width: '950px',
        height: '565px',
        borderRadius: 'inherit',
        maxWidth: '950px',
        maxHeight: '565px',
        '@media screen and (max-width: 950px)': {
            width: 'auto',
        },
        '@media screen and (max-width: 600px)': {
            width: '394px',
            height: '590px',
            maxWidth: '394px',
            margin: '0 auto',
            borderRadius: '12px',
        },
        '@media screen and (max-width: 395px)': {
            width: '95%',
            maxWidth: '95%',
        },
    },
    dialogContent: {
        display: 'flex',
        '@media screen and (max-width: 600px)': {
            display: 'block',
        },
    },
    leftContainer: {
        width: '38.4%',
        padding: '16px 0px 0px',
        marginRight: '34px',
        display: 'flex',
        '@media screen and (max-width: 950px)': {
            width: '50%',
            marginRight: '20px',
        },
        '@media screen and (max-width: 600px)': {
            width: '100%',
            padding: 0,
            marginRight: '0px',
        },
        '& img': {
            width: '100%',
            height: 'auto',
            '@media screen and (min-width: 600px)': {
                maxHeight: '360px',
            },
        },
    },
    dialogHeader: {
        boxShadow: '5px 0px 10px 0px #2F2F2F26',
        padding: '10px 20px',
        zIndex: '1',
        '& h2': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    headerContent: {
        fontSize: '16px',
        letterSpacing: '0.01em',
        lineHeight: '24px',
        margin: 'auto 0',
        '@media screen and (max-width: 600px)': {
            fontSize: '16px',
        },
    },
    closeIcon: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 'auto 0',
        float: 'right',
        cursor: 'pointer',
        '@media screen and (max-width: 600px)': {
            width: '24px',
            height: '24px',
        },
    },
    productName: {
        fontSize: '32px',
        paddingTop: '16px',
        lineHeight: '48px',
        '@media screen and (max-width: 768px)': {
            fontSize: '24px',
            lineHeight: '36px',
            paddingTop: '16px',
        },
    },
    description: {
        fontSize: '18px',
        lineHeight: '26px',
        margin: '12px 0px',
        '& p': {
            margin: '0px',
            padding: '0px',
        },
        '@media screen and (max-width: 600px)': {
            fontSize: '16px',
            lineHeight: '24px',
            margin: '6px 0px',
        },
        '& a': {
            color: theme.palette?.colorPrimary || '#201648',
        },
    },
    rightContainer: {
        width: '60%',
        '@media screen and (max-width: 600px)': {
            width: '100%',
            padding: '0px 28px',
        },
    },
    dialogContentContainer: {
        padding: '8px 28px 8px 44px',
        '@media screen and (max-width: 600px)': {
            padding: '16px 0px',

        },
    },
}));

const AddonInfoModal = ({
    open,
    setOpen,
    imageData,
    description,
    LinkOrReference,
    heading,
    selection,
}) => {
    const classes = useStyle();
    const buildImgPath = (imagePath, imageName) => `${imagePath + imageName}c.jpg?auto=webp`;
    return (
        <Dialog
            PaperProps={{
                className: classes.addonsVerification,
            }}
            open={open}
            maxWidth="xs"
            onClose={() => { setOpen(false); }}
        >
            <DialogTitle className={classes.dialogHeader}>
                <span className={classes.headerContent}><strong>Item Details</strong></span>
                <span role="presentation" onClick={() => { setOpen(false); }}>
                    <CloseIcon className={classes.closeIcon} />
                </span>
            </DialogTitle>
            <DialogContent  className={classes.dialogContentContainer}>
                <div className={classes.dialogContent}>
                    <div className={classes.leftContainer}>
                        <img className={classes.imageWine} src={buildImgPath(imageData?.image?.path, imageData.image?.name)}  alt="addOns" />
                    </div>
                    <div className={classes.rightContainer}>
                        <Typography className={classes.productName}><strong>{ReactHtmlParser(heading)}</strong></Typography>
                        <ReactMarkdown
                            escapeHtml={false}
                            className={classes.description}
                            source={description}
                            renderers={{
                                linkReference: LinkOrReference,
                            }}
                        />
                        {selection || <></>}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
AddonInfoModal.propTypes = {
    setOpen: func.isRequired,
    open: bool,
    imageData: object,
    description: object,
    LinkOrReference: func.isRequired,
    heading: string,
    selection: node,
};
AddonInfoModal.defaultProps = {
    open: false,
    imageData: {},
    description: {},
    heading: '',
    selection: <></>,
};

export default AddonInfoModal;
